module.exports = __webpack_public_path__ + "img/icon_infor1@3x.e48de914.png";